import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class QueueService  {
     /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _http: HttpClient) {
    // Set the defaults
    // this.onKBCategoryChanged = new BehaviorSubject({});
  }

  /**
   * Servicio para enviar mensaje a cola
   * @param message mensaje a enviar
   * @param queueName nombre de la cola
   * @returns 
   */
  sendMessage(message: any, queueName: string){
    let messagetoBase64 = btoa(JSON.stringify(message));
    return this._http.post(`${environment.bpmApiUrl}/api/send-message/${queueName}`, messagetoBase64).pipe(
      map((response: any) => response),
      catchError(e => {
        return throwError(e);
      })
    );
  }

}
